(function () {
  var script = document.currentScript;
  var locator = script && script.closest('.td-kuya-locator__embed');

  if (!locator) {
    return;
  }

  var filters = (locator.getAttribute('data-td-kuya-stockist-filters') || '')
    .split(',')
    .map(function (filter) {
      return filter.trim();
    })
    .filter(Boolean);

  if (!filters.length) {
    loadStockist(locator);
    return;
  }

  window.__stockist_pre_selected_filters = filters;

  loadStockist(locator);

  function loadStockist(root) {
    var src = root.getAttribute('data-td-kuya-stockist-script-src');

    if (!src || (window.Stockist && window.Stockist.loaded)) {
      return;
    }

    var scriptExists = Array.prototype.some.call(document.scripts, function (existingScript) {
      return existingScript.getAttribute('src') === src || existingScript.src === src;
    });

    if (scriptExists) {
      return;
    }

    var stockistScript = document.createElement('script');
    stockistScript.async = true;
    stockistScript.src = src;
    document.head.appendChild(stockistScript);
  }
})();
